import axios from "axios";
import { MenuItem } from "@mui/material";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import { State } from "@progress/kendo-data-query";
import { useExportWithToast } from "../../../Grid/ExcelExport/useExportWithToast";
import { returnNetworkUrls } from "../../../URL/ApplicationUrls";
import { ToolbarDropdownMenu } from "../../../Grid/Toolbar/ToolbarDropdownMenu";
import { UppercaseButton } from "../../../Layout/Buttons/UppercaseButton";
import { IconWithRightMargin } from "../../../Layout/Icons/IconWithRightMargin";
import { KENDO_BUTTON_CLASSES } from "../../../Layout/Buttons/KendoButtons";
import PdsrExcelExportButton from "./PdsrExcelExportButton";
import { AuthorizationPolicies } from "../../../Auth/AuthorizationPolicy";
import RenderAuthorized from "../../../Auth/RenderAuthorized";

export const pdsrOverviewToolbarMenu = () =>
  function PdsrExportMenu(dataState: State, excelExportUrl: string) {
    const pdsrContainerData = "PDSR Container Data";
    const forecastData = "Forecast Data";

    const containerDataExport = useExportWithToast(
      () =>
        axios.get(returnNetworkUrls.reportContainerData, {
          responseType: "blob",
        }),
      `Exporting ${pdsrContainerData}`
    );

    const forecastDataExport = useExportWithToast(
      () =>
        axios.get(returnNetworkUrls.reportForecastData, {
          responseType: "blob",
        }),
      `Exporting ${forecastData}`
    );

    return (
      <RenderAuthorized requiredRoles={AuthorizationPolicies.RequireAdminReadOnlyNetworkRiskLaunch}>
        <ToolbarDropdownMenu text="Exports" key="pdsr-overview-export-menu">
          <MenuItem>
            <PdsrExcelExportButton
              url={excelExportUrl}
              dataState={dataState}
              fileName="PDSR_Overview"
            />
          </MenuItem>

          <MenuItem>
            <UppercaseButton className={KENDO_BUTTON_CLASSES} onClick={() => containerDataExport()}>
              <IconWithRightMargin icon={faFile} />
              {`Export ${pdsrContainerData}`}
            </UppercaseButton>
          </MenuItem>

          <MenuItem>
            <UppercaseButton className={KENDO_BUTTON_CLASSES} onClick={() => forecastDataExport()}>
              <IconWithRightMargin icon={faFile} />
              {`Export ${forecastData}`}
            </UppercaseButton>
          </MenuItem>
        </ToolbarDropdownMenu>
      </RenderAuthorized>
    );
  };
